<template lang="pug">
  vue-perfect-scrollbar.dropdown-cart
    .dropdown-cart__item.row(v-if="$store.getters['cart/total_items'] > 0" v-for="item in $store.getters['cart/items']" :key="item.id")
      .dropdown-cart__item-close(@click.prevent="onRemove(item)")
        font-awesome-icon(:icon="['far', 'trash-alt']")
      .col-3
        router-link(v-if="item.item_code" :to="item.permalink")
          img.dropdown-cart__item-thumbnail(
            :src="'https://www.sparkinter.com/imageproduct/' + item.item_code + '.jpg'"
            v-if="item.item_code"
          )
      .col-9
        .row
          .col-9
            router-link(:to="item.permalink")
              h3.dropdown-cart__item-title {{ item.name }}
        .row
          .col-6
            span.dropdown-cart__item-quantity {{ trans('labels.frontend.cart.table.qty') }} {{ item.quantity | numeral }}
          .col-6
            .dropdown-cart__item-price ฿ {{ item.quantity * (item.sale_price ? item.sale_price : item.price) | numeral }}
    .dropdown-cart__actions
      router-link(:to="{ name: 'cart' }", :title="trans('labels.frontend.cart.cart_view')").btn.btn-primary.btn-block.btn-md.text-white {{ trans('labels.frontend.cart.cart_view') }}
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar/index.vue'
import notify from '../notify';

export default {
  components: {
    VuePerfectScrollbar
  },
  mounted() {
    if (typeof this.$store.getters['cart/id'] !== 'undefined') {
      this.$store.dispatch('cart/get', { id: this.$store.getters['cart/id'] });
    }
  },
  methods: {
    async onRemove(item) {
      await this.$store.dispatch('cart/remove', { id: this.$store.getters['cart/id'], itemId: item.item_code });
      notify.success(this, { title: Lang.get('alerts.frontend.general.deleted_from_cart') });
    },
  },
};
</script>
